export const asthma = {
    'scenarios': {
        "12110": {
            "risk": 0.06,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "0%"
            }
        },
        "12111": {
            "risk": 0.06,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "0%"
            }
        },
        "12112": {
            "risk": 0.06,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "1%"
            }
        },
        "12113": {
            "risk": 0.08,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "24%"
            }
        },
        "12120": {
            "risk": 0.08,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "24%"
            }
        },
        "12121": {
            "risk": 0.08,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "20%"
            }
        },
        "12122": {
            "risk": 0.08,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "26%"
            }
        },
        "12123": {
            "risk": 0.11,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "44%"
            }
        },
        "12130": {
            "risk": 0.14,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "53%"
            }
        },
        "12131": {
            "risk": 0.11,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "42%"
            }
        },
        "12132": {
            "risk": 0.11,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "42%"
            }
        },
        "12133": {
            "risk": 0.22,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.06,
                "reduction": "72%"
            }
        },
        "12210": {
            "risk": 0.08,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "0%"
            }
        },
        "12211": {
            "risk": 0.08,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "0%"
            }
        },
        "12212": {
            "risk": 0.08,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "1%"
            }
        },
        "12213": {
            "risk": 0.11,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "24%"
            }
        },
        "12220": {
            "risk": 0.11,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "24%"
            }
        },
        "12221": {
            "risk": 0.1,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "20%"
            }
        },
        "12222": {
            "risk": 0.11,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "26%"
            }
        },
        "12223": {
            "risk": 0.14,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "44%"
            }
        },
        "12230": {
            "risk": 0.18,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "53%"
            }
        },
        "12231": {
            "risk": 0.14,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "42%"
            }
        },
        "12232": {
            "risk": 0.14,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "42%"
            }
        },
        "12233": {
            "risk": 0.29,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "72%"
            }
        },
        "13110": {
            "risk": 0.07,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "0%"
            }
        },
        "13111": {
            "risk": 0.07,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "0%"
            }
        },
        "13112": {
            "risk": 0.07,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "1%"
            }
        },
        "13113": {
            "risk": 0.09,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "24%"
            }
        },
        "13120": {
            "risk": 0.09,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "24%"
            }
        },
        "13121": {
            "risk": 0.09,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "20%"
            }
        },
        "13122": {
            "risk": 0.09,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "26%"
            }
        },
        "13123": {
            "risk": 0.12,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "44%"
            }
        },
        "13130": {
            "risk": 0.15,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "53%"
            }
        },
        "13131": {
            "risk": 0.12,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "42%"
            }
        },
        "13132": {
            "risk": 0.12,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "42%"
            }
        },
        "13133": {
            "risk": 0.24,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.07,
                "reduction": "72%"
            }
        },
        "13210": {
            "risk": 0.09,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "0%"
            }
        },
        "13211": {
            "risk": 0.09,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "0%"
            }
        },
        "13212": {
            "risk": 0.09,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "1%"
            }
        },
        "13213": {
            "risk": 0.12,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "24%"
            }
        },
        "13220": {
            "risk": 0.12,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "24%"
            }
        },
        "13221": {
            "risk": 0.11,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "20%"
            }
        },
        "13222": {
            "risk": 0.12,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "26%"
            }
        },
        "13223": {
            "risk": 0.16,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "44%"
            }
        },
        "13230": {
            "risk": 0.2,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "53%"
            }
        },
        "13231": {
            "risk": 0.15,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "42%"
            }
        },
        "13232": {
            "risk": 0.15,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "42%"
            }
        },
        "13233": {
            "risk": 0.31,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "72%"
            }
        },
        "14110": {
            "risk": 0.09,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "0%"
            }
        },
        "14111": {
            "risk": 0.08,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "0%"
            }
        },
        "14112": {
            "risk": 0.08,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "1%"
            }
        },
        "14113": {
            "risk": 0.11,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "24%"
            }
        },
        "14120": {
            "risk": 0.11,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "24%"
            }
        },
        "14121": {
            "risk": 0.1,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "20%"
            }
        },
        "14122": {
            "risk": 0.11,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "26%"
            }
        },
        "14123": {
            "risk": 0.15,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "44%"
            }
        },
        "14130": {
            "risk": 0.18,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.09,
                "reduction": "53%"
            }
        },
        "14131": {
            "risk": 0.14,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "42%"
            }
        },
        "14132": {
            "risk": 0.14,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "42%"
            }
        },
        "14133": {
            "risk": 0.29,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.08,
                "reduction": "72%"
            }
        },
        "14210": {
            "risk": 0.11,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "0%"
            }
        },
        "14211": {
            "risk": 0.11,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "0%"
            }
        },
        "14212": {
            "risk": 0.11,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "1%"
            }
        },
        "14213": {
            "risk": 0.14,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "24%"
            }
        },
        "14220": {
            "risk": 0.15,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "24%"
            }
        },
        "14221": {
            "risk": 0.14,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "20%"
            }
        },
        "14222": {
            "risk": 0.15,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "26%"
            }
        },
        "14223": {
            "risk": 0.19,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "44%"
            }
        },
        "14230": {
            "risk": 0.24,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "53%"
            }
        },
        "14231": {
            "risk": 0.19,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "42%"
            }
        },
        "14232": {
            "risk": 0.19,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "42%"
            }
        },
        "14233": {
            "risk": 0.38,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.11,
                "reduction": "72%"
            }
        },
        "15110": {
            "risk": 0.21,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.21,
                "reduction": "0%"
            }
        },
        "15111": {
            "risk": 0.2,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "0%"
            }
        },
        "15112": {
            "risk": 0.21,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "1%"
            }
        },
        "15113": {
            "risk": 0.27,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "24%"
            }
        },
        "15120": {
            "risk": 0.27,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.21,
                "reduction": "24%"
            }
        },
        "15121": {
            "risk": 0.25,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "20%"
            }
        },
        "15122": {
            "risk": 0.27,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "26%"
            }
        },
        "15123": {
            "risk": 0.36,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "44%"
            }
        },
        "15130": {
            "risk": 0.45,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.21,
                "reduction": "53%"
            }
        },
        "15131": {
            "risk": 0.35,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "42%"
            }
        },
        "15132": {
            "risk": 0.35,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "42%"
            }
        },
        "15133": {
            "risk": 0.71,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "72%"
            }
        },
        "15210": {
            "risk": 0.27,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.27,
                "reduction": "0%"
            }
        },
        "15211": {
            "risk": 0.26,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "0%"
            }
        },
        "15212": {
            "risk": 0.27,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "1%"
            }
        },
        "15213": {
            "risk": 0.35,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "24%"
            }
        },
        "15220": {
            "risk": 0.36,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.27,
                "reduction": "24%"
            }
        },
        "15221": {
            "risk": 0.33,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "20%"
            }
        },
        "15222": {
            "risk": 0.36,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "26%"
            }
        },
        "15223": {
            "risk": 0.47,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "44%"
            }
        },
        "15230": {
            "risk": 0.58,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.27,
                "reduction": "53%"
            }
        },
        "15231": {
            "risk": 0.46,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "42%"
            }
        },
        "15232": {
            "risk": 0.46,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "42%"
            }
        },
        "15233": {
            "risk": 0.93,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "72%"
            }
        },
        "22110": {
            "risk": 0.18,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "0%"
            }
        },
        "22111": {
            "risk": 0.18,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "0%"
            }
        },
        "22112": {
            "risk": 0.18,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "1%"
            }
        },
        "22113": {
            "risk": 0.23,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "24%"
            }
        },
        "22120": {
            "risk": 0.24,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "24%"
            }
        },
        "22121": {
            "risk": 0.22,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "20%"
            }
        },
        "22122": {
            "risk": 0.24,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "26%"
            }
        },
        "22123": {
            "risk": 0.31,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "44%"
            }
        },
        "22130": {
            "risk": 0.39,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "53%"
            }
        },
        "22131": {
            "risk": 0.3,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "42%"
            }
        },
        "22132": {
            "risk": 0.3,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "42%"
            }
        },
        "22133": {
            "risk": 0.62,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.18,
                "reduction": "72%"
            }
        },
        "22210": {
            "risk": 0.23,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "0%"
            }
        },
        "22211": {
            "risk": 0.23,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "0%"
            }
        },
        "22212": {
            "risk": 0.23,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "1%"
            }
        },
        "22213": {
            "risk": 0.3,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "24%"
            }
        },
        "22220": {
            "risk": 0.31,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "24%"
            }
        },
        "22221": {
            "risk": 0.28,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "20%"
            }
        },
        "22222": {
            "risk": 0.31,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "26%"
            }
        },
        "22223": {
            "risk": 0.41,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "44%"
            }
        },
        "22230": {
            "risk": 0.5,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "53%"
            }
        },
        "22231": {
            "risk": 0.39,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "42%"
            }
        },
        "22232": {
            "risk": 0.39,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "42%"
            }
        },
        "22233": {
            "risk": 0.8,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "72%"
            }
        },
        "23110": {
            "risk": 0.2,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "0%"
            }
        },
        "23111": {
            "risk": 0.19,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.19,
                "reduction": "0%"
            }
        },
        "23112": {
            "risk": 0.19,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.19,
                "reduction": "1%"
            }
        },
        "23113": {
            "risk": 0.25,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.19,
                "reduction": "24%"
            }
        },
        "23120": {
            "risk": 0.26,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "24%"
            }
        },
        "23121": {
            "risk": 0.24,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.19,
                "reduction": "20%"
            }
        },
        "23122": {
            "risk": 0.26,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.19,
                "reduction": "26%"
            }
        },
        "23123": {
            "risk": 0.34,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.19,
                "reduction": "44%"
            }
        },
        "23130": {
            "risk": 0.42,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.2,
                "reduction": "53%"
            }
        },
        "23131": {
            "risk": 0.33,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.19,
                "reduction": "42%"
            }
        },
        "23132": {
            "risk": 0.33,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.19,
                "reduction": "42%"
            }
        },
        "23133": {
            "risk": 0.67,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.19,
                "reduction": "72%"
            }
        },
        "23210": {
            "risk": 0.26,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "0%"
            }
        },
        "23211": {
            "risk": 0.25,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.25,
                "reduction": "0%"
            }
        },
        "23212": {
            "risk": 0.25,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.25,
                "reduction": "1%"
            }
        },
        "23213": {
            "risk": 0.33,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.25,
                "reduction": "24%"
            }
        },
        "23220": {
            "risk": 0.34,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "24%"
            }
        },
        "23221": {
            "risk": 0.31,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.25,
                "reduction": "20%"
            }
        },
        "23222": {
            "risk": 0.34,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.25,
                "reduction": "26%"
            }
        },
        "23223": {
            "risk": 0.44,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.25,
                "reduction": "44%"
            }
        },
        "23230": {
            "risk": 0.55,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.26,
                "reduction": "53%"
            }
        },
        "23231": {
            "risk": 0.43,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.25,
                "reduction": "42%"
            }
        },
        "23232": {
            "risk": 0.43,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.25,
                "reduction": "42%"
            }
        },
        "23233": {
            "risk": 0.88,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.25,
                "reduction": "72%"
            }
        },
        "24110": {
            "risk": 0.24,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.24,
                "reduction": "0%"
            }
        },
        "24111": {
            "risk": 0.23,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "0%"
            }
        },
        "24112": {
            "risk": 0.24,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "1%"
            }
        },
        "24113": {
            "risk": 0.31,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "24%"
            }
        },
        "24120": {
            "risk": 0.31,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.24,
                "reduction": "24%"
            }
        },
        "24121": {
            "risk": 0.29,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "20%"
            }
        },
        "24122": {
            "risk": 0.31,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "26%"
            }
        },
        "24123": {
            "risk": 0.41,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "44%"
            }
        },
        "24130": {
            "risk": 0.51,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.24,
                "reduction": "53%"
            }
        },
        "24131": {
            "risk": 0.4,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "42%"
            }
        },
        "24132": {
            "risk": 0.4,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "42%"
            }
        },
        "24133": {
            "risk": 0.82,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.23,
                "reduction": "72%"
            }
        },
        "24210": {
            "risk": 0.31,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.31,
                "reduction": "0%"
            }
        },
        "24211": {
            "risk": 0.3,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.3,
                "reduction": "0%"
            }
        },
        "24212": {
            "risk": 0.31,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.3,
                "reduction": "1%"
            }
        },
        "24213": {
            "risk": 0.4,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.3,
                "reduction": "24%"
            }
        },
        "24220": {
            "risk": 0.41,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.31,
                "reduction": "24%"
            }
        },
        "24221": {
            "risk": 0.38,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.3,
                "reduction": "20%"
            }
        },
        "24222": {
            "risk": 0.41,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.3,
                "reduction": "26%"
            }
        },
        "24223": {
            "risk": 0.54,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.3,
                "reduction": "44%"
            }
        },
        "24230": {
            "risk": 0.67,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.31,
                "reduction": "53%"
            }
        },
        "24231": {
            "risk": 0.52,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.3,
                "reduction": "42%"
            }
        },
        "24232": {
            "risk": 0.52,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.3,
                "reduction": "42%"
            }
        },
        "24233": {
            "risk": 1.06,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.3,
                "reduction": "72%"
            }
        },
        "25110": {
            "risk": 0.59,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.59,
                "reduction": "0%"
            }
        },
        "25111": {
            "risk": 0.57,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.57,
                "reduction": "0%"
            }
        },
        "25112": {
            "risk": 0.58,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.57,
                "reduction": "1%"
            }
        },
        "25113": {
            "risk": 0.75,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.57,
                "reduction": "24%"
            }
        },
        "25120": {
            "risk": 0.77,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.59,
                "reduction": "24%"
            }
        },
        "25121": {
            "risk": 0.71,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.57,
                "reduction": "20%"
            }
        },
        "25122": {
            "risk": 0.77,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.57,
                "reduction": "26%"
            }
        },
        "25123": {
            "risk": 1.01,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.57,
                "reduction": "44%"
            }
        },
        "25130": {
            "risk": 1.26,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.59,
                "reduction": "53%"
            }
        },
        "25131": {
            "risk": 0.98,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.57,
                "reduction": "42%"
            }
        },
        "25132": {
            "risk": 0.98,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.57,
                "reduction": "42%"
            }
        },
        "25133": {
            "risk": 2,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.57,
                "reduction": "72%"
            }
        },
        "25210": {
            "risk": 0.76,
            "text": "B",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.76,
                "reduction": "0%"
            }
        },
        "25211": {
            "risk": 0.74,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.74,
                "reduction": "0%"
            }
        },
        "25212": {
            "risk": 0.75,
            "text": "B",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.74,
                "reduction": "1%"
            }
        },
        "25213": {
            "risk": 0.98,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.74,
                "reduction": "24%"
            }
        },
        "25220": {
            "risk": 1,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.76,
                "reduction": "24%"
            }
        },
        "25221": {
            "risk": 0.93,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.74,
                "reduction": "20%"
            }
        },
        "25222": {
            "risk": 1,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.74,
                "reduction": "26%"
            }
        },
        "25223": {
            "risk": 1.32,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.74,
                "reduction": "44%"
            }
        },
        "25230": {
            "risk": 1.64,
            "text": "A",
            "additional-text": true,
            "post-treatment": {
                "risk": 0.76,
                "reduction": "53%"
            }
        },
        "25231": {
            "risk": 1.28,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.74,
                "reduction": "42%"
            }
        },
        "25232": {
            "risk": 1.28,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.74,
                "reduction": "42%"
            }
        },
        "25233": {
            "risk": 2.6,
            "text": "A",
            "additional-text": false,
            "post-treatment": {
                "risk": 0.74,
                "reduction": "72%"
            }
        }
    }
}
